import { Link } from "react-router-dom";

const SimilarInfluencers = ({ influencers, currentName }) => (
  <div>
    <h2 className="lg:text-2xl text-lg font-semibold mb-6">
      Influencers similar to {currentName || "this creator"}
    </h2>

    <div className="flex gap-6 overflow-x-auto pb-2">
      {influencers.map((i) => (
        <Link
          key={i._id || i.id || i.username}
          to={`/marketplace/influencer/${i.username}`}
          className="min-w-[240px] block rounded-xl overflow-hidden border border-gray-200 hover:border-gray-400 hover:shadow-md transition"
        >
          <img src={i.image} alt={i.name} className="rounded-t-xl h-64 w-full object-cover" />
          <div className="p-3 bg-white">
            <p className="font-medium">{i.name}</p>
            <p className="text-gray-500 text-sm">{i.location}</p>
          </div>
        </Link>
      ))}
    </div>
  </div>
);
  
  export default SimilarInfluencers;
  